import { createContext } from 'react';

import type {
  ConfirmContext,
  Nullable,
} from '@app/providers/NewConfirmProvider/NewConfirmProvider.types';

export const ConfirmCtx = createContext<Nullable<ConfirmContext>>(null);
